import { Box } from "@mui/material";
import ShiftContent from "./components/shiftContent";

const shiftConnectPage = () => {
  return (
    <Box
      sx={{
        p: { xs: 2, sm: 3 },
        mt: { xs: 4, sm: 6 },
        mx: "auto",
        width: "100%",
        boxSizing: "border-box",
      }}
    >
      <ShiftContent />
    </Box>
  );
};

export default shiftConnectPage;
